import { BaseEntity } from "yt-ng-framework";

export class IzvodStavka extends BaseEntity{
    constructor(){
        super();
    }   

    IzvodID: number = null;
    RB: number = null;
    KomitentID: number = null;
    BrojFakture: string = null;
    NacinPlacanjaID: number = null;
    Duguje :number = null;
    Potrazuje: number = null;
    Opis: string = null;
    OrgJedID: number = null;
    BrojFaktureIzMinibiz: number = null;
    BrojFaktureNijeMinibiz: string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.IzvodID = input.IzvodID;
        this.RB = input.RB;
        this.KomitentID = input.KomitentID;
        this.BrojFakture = input.BrojFakture;
        this.NacinPlacanjaID = input.NacinPlacanjaID;
        this.Duguje = input.Duguje;
        this.Potrazuje = input.Potrazuje;
        this.Opis = input.Opis;
        this.OrgJedID = input.OrgJedID;
        this.BrojFaktureIzMinibiz = input.BrojFaktureIzMinibiz;
        this.BrojFaktureNijeMinibiz = input.BrojFaktureNijeMinibiz;
        return this;
    }

    Serialize(input:IzvodStavka){
        return input;
    }
}
